<template>
  <div class="mb3">
    <div v-if="accomodations.data && Object.keys(accomodations.data).length > 0" class="row max_2">
      <div class="home_acco skeleton" v-for="(item, index) in accomodations.data"
        :class="{ 'larger': accomodations.data.length == 2 }">
        <a v-bind:href="`${currentUrl}/accomodations/${item.id}`">
          <div class="room-thumb" :class="{ 'larger': Object.keys(accomodations.data).length == 2 }">

            <img v-if="Object.keys(accomodations.data).length == 2" v-bind:src="mipmap(item.spotlightimage, 400)" alt=""
              class="room-image" srcset="" loading="lazy" />
            <img v-else v-bind:src="mipmap(item.spotlightimage, 400)" alt="" class="room-image" srcset=""
              loading="lazy" />
            <div class="main">
              <div class="info">
                <h5>{{ item.name }}</h5>
                <span class="location">{{ item.city }}, {{ item.state }}</span>
              </div>
            </div>
            <a :href="$termsUrl + '#sponsored'" target="blank" v-if="item.promotion && item.promotion == true"
              class="bg-black bg-opacity-50 backdrop-blur-sm p-2 rounded-full absolute left-2 top-2 text-gray-200 hover:text-yellow-400 z-5 transition-all duration-500 flex items-center justify-start group max-w-[32px] hover:max-w-full overflow-hidden cursor-help">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512" class="w-4 h-4 shrink-0">
                <path
                  d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                </path>
              </svg>
              <span class="text-xs ml-1 opacity-0 transition group-hover:opacity-100 text-white">{{ $t('sponsored')
              }}</span>
            </a>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            accomodations: { data: [] },
            currentUrl: window.location.origin,
        };
    },
    props: {
        cache_acco: {
            type: [Array, Object, String],
            required: true
        }
    },

    methods: {
        mipmap(src, res) {
            if (src.includes('https://media.xmlcal.com')) {
                const imgblocks = src.split("/");
                const imgfile = imgblocks[imgblocks.length - 1];
                const thumbnailimgsmall = imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
                imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
                return imgblocks.join("/");
            } else {
                return src;
            }
        }
    },

    created() {
        this.accomodations.data = typeof this.cache_acco === 'string'
            ? JSON.parse(this.cache_acco)
            : this.cache_acco;
    },
};

</script>
